import { Box3, Matrix4, Mesh, Quaternion, Vector3 } from 'three';
import { HsbProject } from './hsb-project';
import { ShareReference } from './sharereference';
var convert = require('convert-units');
var length = require('convert-units/lib/definitions/length');

export const hsbIFCDocs = 'hsbIFCDocs';
export const hsbIFCInternal = 'hsbIFCInternal';
export const hsbIFCGroupStructure = 'hsbIFCGroupStructure';
export const hsbIFCElementData = 'hsbIFCElementData';
export const Item = 'Item';

export const IFCWALL = 'IFCWALL';
export const IFCBEAM = 'IFCBEAM';
export const IFCPLATE = 'IFCPLATE';
export const IFCCOLUMN = 'IFCCOLUMN';
export const IFCMEMBER = 'IFCMEMBER';
export const IFCBUILDINGELEMENTPROXY = 'IFCBUILDINGELEMENTPROXY';
export const IFCSIP = 'IFCSIP';
export const IFCSLAB = 'IFCSLAB';

export const GROUP = 'Group';
export const WALL = 'Wall';
export const WALLSIP = 'WallSIP';
export const BEAM = 'Beam';
export const OPENING = 'Opening';
export const SHEET = 'Sheet';
export const SIP = 'SIP';
export const ROOF = 'Roof';
export const ROOFSIP = 'RoofSIP';
export const MASSGROUP = 'MassGroup';
export const MASSELEMENT = 'MassElement';
export const TSLINST = 'TslInst';
export const GENERICMODEL = 'GenericModel';
export const FASTENERASSEMBLYENT = 'FastenerAssemblyEnt';
export const METALPARTCOLLECTIONENTITY = 'MetalPartCollectionEnt';
export const COLLECTIONENTITY = 'CollectionEntity';
export const TRUSSENTITY = 'TrussEntity';
export const BLOCKREFERENCE = 'BlockReference';
export const GRID = 'Grid';
export const DIMENSION = 'Dimension';
export const FREEFORM = 'FreeForm';
export const TRUCK = 'Truck';
export const TRUCKLAYER = 'TruckLayer';
export const TRUCKPACK = 'TruckPack';
export const TRUCKSTACK = 'TruckStack';
export const TRUCKITEM = 'TruckItem';
export const TRUCKENTITY = 'TruckEntity';
export const TRUCKLOADLAYOUTBODY = 'TruckLoadLayoutBody';
export const TRUCKLOADLAYOUTBODYAXLE = 'TruckLoadLayoutBodyAxle';
export const TRUCKLOADLAYOUTBODYAXLEFACE = 'TruckLoadLayoutBodyAxleFace';
export const TRUCKLOADLAYOUTBODYJOIN = 'TruckLoadLayoutBodyJoin';
export const TRUCKLOADLAYOUTCAB = 'TruckLoadLayoutCad';
export const TRUCKLOADLAYOUTBODYFACE = 'TruckLoadLayoutBodyFace';
export const TRUCKLOADSPACE = 'TruckLoadSpace';
export const TRUCKLOADSPACEFACE = 'TruckLoadSpaceFace';
export const TRUCKLOADPACKAGE = 'TruckLoadPackage';
export const GROUNDPAD = 'GroundPad';
export const STACK = 'Stack';
export const PACK = 'Pack';
export const NESTING = 'Nesting';
export const MULTIWALL = 'MultiWall';
export const FACTORYUNIT = 'FactoryUnit';
export const FACTORYBUFFER = 'FactoryBuffer';
export const FACTORYENTITY = 'FactoryEntity';

export const NONHSB = 'NONHSB';

export const NodeType = {
    Geom: 'geom',
    Item: 'item',
    Items: 'items',
    Model: 'model',
    ModelInfo: 'modelinfo',
    LMVModel: 'lmvmodel',
    RefItem: 'refitem',
    Folder: 'folder',
    Configuration: 'configuration',
    Project: 'project',
    Communication: 'communication',
    Undefined: 'undefined',
    Root: 'root',
    Template: 'template',
    Chat: 'chat',
    Placement: 'placement',
    Stack: 'stack',
    HsbModel: 'hsbmodel',
    HsbSet: 'hsbset',
    DocLink: 'doclink',
    Truck: 'truck',
    HsbShareGeom: 'hsbshare.geom',
    DbNodes: 'dbnodes',
};
export const RefItemType = {
    Parent: 'parent',
    Child: 'child',
};
export const HsbObjectType = {
    HsbElement: 'hsbelement',
    HsbElementWall: 'hsbelementwall',
    HsbElementWallSIP: 'hsbelementwallSIP',
    HsbElementRoof: 'hsbelementroof',
    HsbElementRoofSIP: 'hsbelementroofsip',
    HsbGroup: 'hsbgroup',
    HsbEntity: 'hsbentity',
    HsbBeam: 'hsbbeam',
    HsbOpenings: 'hsbopening',
    HsbSheet: 'hsbsheet',
    HsbSIP: 'hsbsip',
    HsbMassGroup: 'hsbmassgroup',
    HsbMassEntity: 'hsbmassentity',
    HsbMassElement: 'hsbmasselement',
    HsbTslInst: 'hsbtslinst',
    HsbGenericModel: 'hsbgenericmodel',
    HsbFastenerAssemblyEnt: 'hsbfastenerassemblyent',
    HsbMetalPartCollectionEnt: 'hsbmetalpartcollectionentity',
    HsbCollectionEntity: 'hsbcollectionentity',
    HsbTrussEntity: 'hsbtrussentity',
    HsbBlockReference: 'hsbblockreference',
    HsbGrid: 'hsbgrid',
    HsbDimension: 'hsbdimension',
    HsbTruck: 'hsbtruck',
    HsbTruckLayer: 'hsbtrucklayer',
    HsbTruckPack: 'hsbtruckpack',
    HsbTruckStack: 'hsbtruckstack',
    HsbTruckItem: 'hsbtruckitem',
    HsbStack: 'hsbstack',
    HsbPack: 'hsbpack',
    HsbNesting: 'hsbnesting',
    HsbNestingBase: 'hsbnestingbase',
    HsbMultiWall: 'hsbmultiwall',
    HsbFactoryUnit: 'hsbfactoryunit',
    HsbFactoryBuffer: 'hsbfactorybuffer',
    HsbFactoryEntity: 'hsbfactoryentity',
    HsbTruckEntity: 'hsbtruckentity',
    HsbTruckLoadLayoutBody: 'hsbtruckloadlayoutbody',
    HsbTruckLoadLayoutBodyAxle: 'hsbtruckloadlayoutbodyaxle',
    HsbTruckLoadLayoutBodyAxleFace: 'hsbtruckloadlayoutbodyaxleface',
    HsbTruckLoadLayoutBodyJoin: 'hsbtruckloadlayoutbodyjoin',
    HsbTruckLoadLayoutCab: 'hsbtruckloadlayoutcad',
    HsbTruckLoadLayoutBodyFace: 'hsbtruckloadlayoutbodyface',
    HsbTruckLoadSpace: 'hsbtruckloadspace',
    HsbTruckLoadSpaceFace: 'hsbtruckloadspaceface',
    HsbTruckLoadPackage: 'hsbtruckloadpackage',
    HsbGroundPad: 'hsbgroundpad',
};
export const IFCObjectType = {
    IfcAllObjects: 'ifcallobjects',
    IfcBuildingSite: 'ifcbuildingsite',
    IfcBuilding: 'ifcbuilding',
    IfcBuildingStorey: 'ifcbuildingstorey',
    IfcSpace: 'ifcspace',
    IfcWall: 'ifcwall',
    IfcWallStandardcase: 'ifcwallstandardcase',
    IfcCurtainWall: 'ifccurtainwall',
    IfcWindow: 'ifcwindow',
    IfcDoor: 'ifcdoor',
    IfcBeam: 'ifcbeam',
    IfcRoof: 'ifcfoor',
    IfcSlab: 'ifcslab',
};
export const ObjectType = {
    NoSet: 'notset',
    IfcSpace: IFCObjectType.IfcSpace,
    IfcBuilding: IFCObjectType.IfcBuilding,
    IfcwallStandardcase: IFCObjectType.IfcWallStandardcase,

    HsbElement: HsbObjectType.HsbElement,
    HsbElementWall: HsbObjectType.HsbElementWall,
    HsbElementWallSIP: HsbObjectType.HsbElementWallSIP,
    HsbElementRoof: HsbObjectType.HsbElementRoof,
    HsbElementRoofSIP: HsbObjectType.HsbElementRoofSIP,
    HsbGroup: HsbObjectType.HsbGroup,
    HsbEntity: HsbObjectType.HsbEntity,
    HsbBeam: HsbObjectType.HsbBeam,
    HsbOpening: HsbObjectType.HsbOpenings,
    HsbSheet: HsbObjectType.HsbSheet,
    HsbSIP: HsbObjectType.HsbSIP,
    HsbMassGroup: HsbObjectType.HsbMassGroup,
    HsbMassElement: HsbObjectType.HsbMassElement,
    HsbTslInst: HsbObjectType.HsbTslInst,
    HsbGenericModel: HsbObjectType.HsbGenericModel,
    HsbFastenerAssemblyEnt: HsbObjectType.HsbFastenerAssemblyEnt,
    HsbMetalPartCollectionEnt: HsbObjectType.HsbMetalPartCollectionEnt,
    HsbCollectionEntity: HsbObjectType.HsbCollectionEntity,
    HsbTrussEntity: HsbObjectType.HsbTrussEntity,
    HsbBlockReference: HsbObjectType.HsbBlockReference,
    HsbGrid: HsbObjectType.HsbGrid,
    HsbDimension: HsbObjectType.HsbDimension,
    HsbTruck: HsbObjectType.HsbTruck,
    HsbTruckLayer: HsbObjectType.HsbTruckLayer,
    HsbTruckPack: HsbObjectType.HsbTruckPack,
    HsbTruckStack: HsbObjectType.HsbTruckStack,
    HsbTruckItem: HsbObjectType.HsbTruckItem,
    HsbStack: HsbObjectType.HsbStack,
    HsbPack: HsbObjectType.HsbPack,
    HsbNesting: HsbObjectType.HsbNesting,
    HsbNestingBase: HsbObjectType.HsbNestingBase,
    HsbMultiWall: HsbObjectType.HsbMultiWall,
    HsbFactoryUnit: HsbObjectType.HsbFactoryUnit,
    HsbFactoryBuffer: HsbObjectType.HsbFactoryBuffer,
    HsbFactoryEntity: HsbObjectType.HsbFactoryEntity,
    HsbTruckEntity: HsbObjectType.HsbTruckEntity,
    HsbTruckLoadLayoutBody: HsbObjectType.HsbTruckLoadLayoutBody,
    HsbTruckLoadLayoutBodyAxle: HsbObjectType.HsbTruckLoadLayoutBodyAxle,
    HsbTruckLoadLayoutBodyAxleFace: HsbObjectType.HsbTruckLoadLayoutBodyAxleFace,
    HsbTruckLoadLayoutBodyJoin: HsbObjectType.HsbTruckLoadLayoutBodyJoin,
    HsbTruckLoadLayoutCab: HsbObjectType.HsbTruckLoadLayoutCab,
    HsbTruckLoadLayoutBodyFace: HsbObjectType.HsbTruckLoadLayoutBodyFace,
    HsbTruckLoadSpace: HsbObjectType.HsbTruckLoadSpace,
    HsbTruckLoadSpaceFace: HsbObjectType.HsbTruckLoadSpaceFace,
    HsbTruckLoadPackage: HsbObjectType.HsbTruckLoadPackage,
    HsbGroundPad: HsbObjectType.HsbGroundPad,
};
export enum SceneLayerName{
    Entities = 'entities',
    Entity = 'entity',
    Labels = 'labels',
    Label = 'label',
    Arrow = 'arrow',
    DocIcons ='docicons',
    DocIcon = 'docicon',
    PanelDimensions = 'paneldimensions',
    FactoryLayout = 'factorylayout',
    FactoryEntities = 'factoryentities',
    FactoryEntityLabel = 'factoryentitylabel',
};
export const IconFolder = '/Config/Icons';
export const PackageModelId = 'packageModel';

export const ModelInfoTemplate = {
    nodetype: NodeType.Geom,
    itemtype: NodeType.ModelInfo,
    visible: false,
    properties: [
        {
            data: {
                label: 'Data Link',
                key: 'iconlink',
                value: '',
                datatype: {
                    type: 'url',
                },
            },
        },
    ],
};

export const _corefiletypes = {
    '.configuration': 1,
    '.root': 1,
    '.node': 1,
    '.mvo': 1,
    '.project': 1,
    '.hsbshareproject': 1,
    '.hsbsharemodel': 1,
    '.hsbshareconfig': 1,
    '.modelnode': 1,
    '.hsb': 1,
    '.json': 1,
};
export const _systemextensions = { hsb: 1, json: 1 };

export const newGuid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-mixed-operators
        var r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

export class Units {
    _unit: string = 'mm';

    constructor(unit: string = 'mm') {
        this.unit = unit;
    }

    get unit() {
        return this._unit;
    }
    set unit(unit) {
        unit = unit.toLowerCase();

        let hit =
            // Metric search
            Object.keys(length['metric']).find((key: string) => {
                let value = length['metric'][key];
                return unit === key || unit === value.name.singular.toLowerCase() || unit === value.name.plural.toLowerCase();
            }) ??
            // Imperial search
            Object.keys(length['imperial']).find((key: string) => {
                let value = length['imperial'][key];
                return unit === key || unit === value.name.singular.toLowerCase() || unit === value.name.plural.toLowerCase();
            }) ??
            // Default is mm
            'mm';

        this._unit = hit;
    }
    get factor() {
        //return 1;
        return convert(1).from(this.unit).to('mm');
    }
    convert(value: number) {
        return convert(value).from(this.unit).to('mm');
    }
}

export class Property {
    _key!: string;
    _category: string;
    _value: any;
    _datatype: { type: string };
    _pdfdoc: any;
    _expose: boolean;
    _translationKey: string | undefined;
    _translationCategory: string | undefined;
    constructor(key: string, category: string, value: any, expose?: boolean, translationKey?: string, translationCategory?: string) {
        if (key) {
            this._key = key.toLowerCase().trim();
        }

        this._category = category.toLowerCase();
        this._value = value;
        this._datatype = { type: 'string' };
        this._expose = expose ?? false;
        this._translationKey = key;
        this._translationCategory = category;
        if (translationKey !== '') {
            this._translationKey = translationKey;
        }
        if (translationCategory !== '') {
            this._translationCategory = translationCategory;
        }
        if (value instanceof Vector3) {
            this._datatype = { type: 'pt3d' };
        }
    }

    get key() {
        return this._key;
    }
    set key(key) {
        this._key = key;
    }

    get datatype() {
        return this._datatype;
    }
    set datatype(datatype) {
        this._datatype = datatype;
    }

    get category() {
        return this._category;
    }
    set category(category) {
        this._category = category;
    }
    get val() {
        return this._value;
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
    }

    get pdfdoc() {
        return this._pdfdoc;
    }
    set pdfdoc(pdfdoc) {
        this._pdfdoc = pdfdoc;
    }

    get expose() {
        return this._expose;
    }
    set expose(expose) {
        this._expose = expose;
    }

    get translationKey() {
        return this._translationKey;
    }
    set translationKey(translationKey) {
        this._translationKey = translationKey;
    }

    get translationCategory() {
        return this._translationCategory;
    }

    set translationCategory(translationCategory) {
        this._translationCategory = translationCategory;
    }
}

function equals(lhs: THREE.Vector3, rhs: THREE.Vector3, epsilon = Number.EPSILON) {
    return Math.abs(lhs.x - rhs.x) < epsilon && Math.abs(lhs.y - rhs.y) < epsilon && Math.abs(lhs.z - rhs.z) < epsilon;
}
export class CoordSys {
    ptOrg: Vector3;
    vecX: Vector3;
    vecY: Vector3;
    vecZ: Vector3;
    constructor() {
        this.ptOrg = new Vector3();
        this.vecX = new Vector3(1, 0, 0);
        this.vecY = new Vector3(0, 1, 0);
        this.vecZ = new Vector3(0, 0, 1);
    }

    clone() {
        try {
            var newcoordsys = new CoordSys();
            newcoordsys.ptOrg = this.ptOrg.clone();
            newcoordsys.vecX = this.vecX.clone();
            newcoordsys.vecY = this.vecY.clone();
            newcoordsys.vecZ = this.vecZ.clone();
            return newcoordsys;
        } catch (err) {
            console.error(err, this);
            throw err;
        }
    }

    static fromObject(coordSysObj: any) {
        let coordSys = new CoordSys();
        coordSys.ptOrg = new Vector3(coordSysObj.ptOrg.x, coordSysObj.ptOrg.y, coordSysObj.ptOrg.z);
        coordSys.vecX = new Vector3(coordSysObj.vecX.x, coordSysObj.vecX.y, coordSysObj.vecX.z);
        coordSys.vecY = new Vector3(coordSysObj.vecY.x, coordSysObj.vecY.y, coordSysObj.vecY.z);
        coordSys.vecZ = new Vector3(coordSysObj.vecZ.x, coordSysObj.vecZ.y, coordSysObj.vecZ.z);
        return coordSys;
    }

    static fromMatrix4(matrix: Matrix4): CoordSys {
        var coordsys = new CoordSys();
        var elem = matrix.elements;

        coordsys.vecX.x = elem[0];
        coordsys.vecX.y = elem[1];
        coordsys.vecX.z = elem[2];

        coordsys.vecY.x = elem[4];
        coordsys.vecY.y = elem[5];
        coordsys.vecY.z = elem[6];

        coordsys.vecZ.x = elem[8];
        coordsys.vecZ.y = elem[9];
        coordsys.vecZ.z = elem[10];

        coordsys.ptOrg.x = elem[12];
        coordsys.ptOrg.y = elem[13];
        coordsys.ptOrg.z = elem[14];
        return coordsys;
    }
    fromMatrix4(matrix: Matrix4): CoordSys {
        var elem = matrix.elements;
        this.vecX.x = elem[0];
        this.vecX.y = elem[1];
        this.vecX.z = elem[2];

        this.vecY.x = elem[4];
        this.vecY.y = elem[5];
        this.vecY.z = elem[6];

        this.vecZ.x = elem[8];
        this.vecZ.y = elem[9];
        this.vecZ.z = elem[10];

        this.ptOrg.x = elem[12];
        this.ptOrg.y = elem[13];
        this.ptOrg.z = elem[14];
        return this;
    }
    reset() {
        this.ptOrg = new Vector3(0, 0, 0);
        this.vecX = new Vector3(1, 0, 0);
        this.vecY = new Vector3(0, 1, 0);
        this.vecZ = new Vector3(0, 0, 1);
    }

    getMatrix4() {
        let matrix4 = new Matrix4();

        var elem = matrix4.elements;

        elem[0] = this.vecX.x;
        elem[1] = this.vecX.y;
        elem[2] = this.vecX.z;

        elem[4] = this.vecY.x;
        elem[5] = this.vecY.y;
        elem[6] = this.vecY.z;

        elem[8] = this.vecZ.x;
        elem[9] = this.vecZ.y;
        elem[10] = this.vecZ.z;

        elem[12] = this.ptOrg.x;
        elem[13] = this.ptOrg.y;
        elem[14] = this.ptOrg.z;

        return matrix4;
    }

    transformVector(vec: Vector3) {
        let vecResolved = new Vector3();

        let vecX = this.vecX.clone().multiplyScalar(vec.x);
        let vecY = this.vecY.clone().multiplyScalar(vec.y);
        let vecZ = this.vecZ.clone().multiplyScalar(vec.z);

        vecResolved.add(vecX).add(vecY).add(vecZ);

        //vec = vec.x * this.vecX + vec.y * this.vecY + vec.z * this.vecZ;
        return vecResolved;
    }

    transformPoint(pt: Vector3) {
        let vecX = this.vecX.clone().multiplyScalar(pt.x);
        let vecY = this.vecY.clone().multiplyScalar(pt.y);
        let vecZ = this.vecZ.clone().multiplyScalar(pt.z);

        pt = this.ptOrg.clone().add(vecX).add(vecY).add(vecZ);

        //pt = this.ptOrg + pt.x* this.vecX + pt.y * this.vecY + pt.z* this.vecZ;
        return pt;
    }

    transformBy(coordSys: CoordSys) {
        if (coordSys == null) return; // identity transformation assumed
        let coordSysClone = coordSys.clone();

        let vecX = coordSysClone.transformVector(this.vecX.clone());
        let vecY = coordSysClone.transformVector(this.vecY.clone());
        let vecZ = coordSysClone.transformVector(this.vecZ.clone());
        let ptOrg = coordSysClone.transformPoint(this.ptOrg.clone());

        this.vecX = vecX;
        this.vecY = vecY;
        this.vecZ = vecZ;
        this.ptOrg = ptOrg;
    }

    inverse() {
        let matrixInverse = new Matrix4();
        let matrix4 = this.getMatrix4();
        matrixInverse.copy(matrix4).invert();
        return this.fromMatrix4(matrixInverse);
    }
    alignToNewCoordsys(newposCoordSys: CoordSys) {
        var moveMatrix = new Matrix4();

        this.setToAlignCoordSys(moveMatrix, this, newposCoordSys);
        return this.fromMatrix4(moveMatrix);
    }

    setToAlignCoordSys(matrix: Matrix4, fromCoordSys: CoordSys, toCoordSys: CoordSys) {
        var matrixFrom = new Matrix4();
        var matrixTo = new Matrix4();

        matrixFrom.set(
            fromCoordSys.vecX.x,
            fromCoordSys.vecY.x,
            fromCoordSys.vecZ.x,
            fromCoordSys.ptOrg.x,
            fromCoordSys.vecX.y,
            fromCoordSys.vecY.y,
            fromCoordSys.vecZ.y,
            fromCoordSys.ptOrg.y,
            fromCoordSys.vecX.z,
            fromCoordSys.vecY.z,
            fromCoordSys.vecZ.z,
            fromCoordSys.ptOrg.z,
            0,
            0,
            0,
            1
        );

        matrix.copy(matrixFrom).invert();

        matrixTo.set(
            toCoordSys.vecX.x,
            toCoordSys.vecY.x,
            toCoordSys.vecZ.x,
            toCoordSys.ptOrg.x,
            toCoordSys.vecX.y,
            toCoordSys.vecY.y,
            toCoordSys.vecZ.y,
            toCoordSys.ptOrg.y,
            toCoordSys.vecX.z,
            toCoordSys.vecY.z,
            toCoordSys.vecZ.z,
            toCoordSys.ptOrg.z,
            0,
            0,
            0,
            1
        );

        matrix.multiply(matrixTo);
        return matrix;
    }
    isEqual(rhs: CoordSys) {
        return equals(this.ptOrg, rhs.ptOrg) && equals(this.vecX, rhs.vecX) && equals(this.vecY, rhs.vecY) && equals(this.vecZ, rhs.vecZ);
    }
}

export class HsbEntity {
    private _handle: string;
    elementCoordSys!: CoordSys;
    initialCoordSys!: CoordSys;
    geometryFactory: any;
    dimensions: any;
    elementhandle: any;
    hsbmodel!: HsbModel;
    object: THREE.Object3D | null = null;
    truckPackageEntity: any;
    ifcid: any;
    searchnode: any;
    geomhandle?: any;
    private _number!: number;
    public get number(): number {
        return this._number;
    }
    public set number(v: number) {
        this._number = v;
    }
    ptarrow?: THREE.Vector3;
    zoneindex?: number;
    private _posnum!: number;
    public get posnum(): number {
        return this._posnum;
    }
    public set posnum(v: number) {
        this._posnum = v;
    }
    instanceId!: number;

    private _visible: boolean = true;
    public get visible(): boolean {
        return this._visible;
    }
    public set visible(v: boolean) {
        this._visible = v;
    }

    private _highlighted: boolean = false;
    public get highlighted(): boolean {
        return this._highlighted;
    }
    public set highlighted(v: boolean) {
        this._highlighted = v;
    }

    public get handle(): string {
        return this._handle;
    }
    public set handle(handle: string) {
        this._handle = handle;
    }

    private _groups: any[];
    public get groups() {
        return this._groups;
    }

    private _type: string;
    public get type() {
        return this._type;
    }
    public set type(type) {
        this._type = type;
    }
    _zone: string | number;
    get zone() {
        return this._zone;
    }
    set zone(zone) {
        this._zone = zone;
    }

    _properties: any[];
    get properties() {
        return this._properties;
    }
    set properties(properties) {
        this._properties = properties;
    }

    private _props: any;
    get props() {
        return this._props;
    }

    private _boundingBox: Box3;
    public get boundingBox(): Box3 {
        return this._boundingBox;
    }
    public set boundingBox(boundingBox) {
        this._boundingBox = boundingBox;
    }

    private _objecttype: string;
    get objecttype() {
        return this._objecttype;
    }
    set objecttype(objecttype) {
        this._objecttype = objecttype;
    }

    private _coordSys: CoordSys;
    get coordSys() {
        return this._coordSys;
    }
    set coordSys(coordSys) {
        this._coordSys = coordSys;
    }

    fragNode: any;
    get dbId() {
        return this.fragNode?.dbId;
    }

    private _hsbMap: any;
    get hsbMap() {
        return this._hsbMap;
    }
    set hsbMap(hsbMap) {
        this._hsbMap = hsbMap;
    }
    getDislayName() {
        return this.type;
    }

    private _node!: Node;
    public get node(): Node {
        return this._node;
    }
    public set node(v: Node) {
        this._node = v;
    }

    group!: Group;
    // Handles of all child entities
    parent!: HsbEntity;
    entities!: HsbEntity[];
    bodydata: any;

    constructor(handle: string | number, type: string, objecttype: string, zone: number | string) {
        this._handle = (handle.toString ? handle.toString() : handle) as string;
        this._groups = [];
        this._type = type;
        this._zone = zone;
        this._properties = [];
        this._props = {};
        this._boundingBox = new Box3();
        this._objecttype = ObjectType.NoSet;
        this._coordSys = new CoordSys();
        this._objecttype = objecttype;
        this._visible = true;
    }

    traverse(callback: (...args: any) => any) {
        callback(this);
        const children = this.entities;
        for (let i = 0, l = children.length; i < l; i++) {
            children[i].traverse(callback);
        }
    }

    traverseAncestors(callback: (...args: any) => any) {
        callback(this);
        const parent = this.parent;
        if (!!parent) parent.traverseAncestors(callback);
    }

    computeBoundingBoxFromBodyData(alignment?: THREE.Matrix4) {
        if (this._boundingBox.isEmpty() && this.bodydata) {
            // Transform the vertex pts to world.
            // Now transform this by world.
            var coordsys = this.bodydata.coordSys;
            var matrix4 = alignment ?? new Matrix4();
            coordsys.setToAlignCoordSys(matrix4, new CoordSys(), coordsys);

            this.bodydata.vertexpts.forEach((pt: THREE.Vector3) => {
                pt.applyMatrix4(matrix4);
            });

            this._boundingBox = this.getBodyBoundingBox(this.bodydata);
        }
    }

    getBodyBoundingBox(bodyData: any) {
        if (!bodyData) throw new Error('HsbEntity.getBodyBoundingBox(): bodyData can not be undefined!');

        let boundingBox = new Box3();
        boundingBox.max.x = Math.max.apply(
            Math,
            bodyData.vertexpts.map(function (pt: THREE.Vector3) {
                return pt.x;
            })
        );
        boundingBox.min.x = Math.min.apply(
            Math,
            bodyData.vertexpts.map(function (pt: THREE.Vector3) {
                return pt.x;
            })
        );
        boundingBox.max.y = Math.max.apply(
            Math,
            bodyData.vertexpts.map(function (pt: THREE.Vector3) {
                return pt.y;
            })
        );
        boundingBox.min.y = Math.min.apply(
            Math,
            bodyData.vertexpts.map(function (pt: THREE.Vector3) {
                return pt.y;
            })
        );
        boundingBox.max.z = Math.max.apply(
            Math,
            bodyData.vertexpts.map(function (pt: THREE.Vector3) {
                return pt.z;
            })
        );
        boundingBox.min.z = Math.min.apply(
            Math,
            bodyData.vertexpts.map(function (pt: THREE.Vector3) {
                return pt.z;
            })
        );
        return boundingBox;
    }

    getLocalBody(coordSys: CoordSys) {
        if (this.bodydata && coordSys) {
            var matrix4 = new Matrix4();
            coordSys.setToAlignCoordSys(matrix4, coordSys, new CoordSys());

            let vertexpts = this.bodydata.vertexpts.map((pt: THREE.Vector3) => {
                return pt.clone().applyMatrix4(matrix4);
            });
            let bodyData = { vertexpts: vertexpts };
            return bodyData;
        }
        return null;
    }

    getCoordSysLocal(): CoordSys {
        let entityCoordSys = this.elementCoordSys ? this.elementCoordSys : this.coordSys;
        let matrix4Local = entityCoordSys.getMatrix4();
        var matrix4 = new Matrix4();
        entityCoordSys.setToAlignCoordSys(matrix4, entityCoordSys, new CoordSys());
        matrix4Local.multiplyMatrices(matrix4, matrix4Local);

        return new CoordSys().fromMatrix4(matrix4Local);
    }

    getBoundingBoxLocal() {
        let boundingBox = new Box3();
        let entityCoordSys = this.elementCoordSys ? this.elementCoordSys : this.coordSys;

        let localBodyData = this.getLocalBody(entityCoordSys);
        if (localBodyData) {
            boundingBox = this.getBodyBoundingBox(localBodyData);
        } else {
            boundingBox = this.boundingBox;
        }

        return boundingBox;
    }

    setFactoryVisibilityforZone(zone: number) {
        this.geometryFactory.visible = zone === this.zone;
    }

    setdimensionvisibility(visible: boolean) {
        if (this.dimensions != null) {
            this.dimensions.visible = visible;
        }
    }
    getproperty(key: string) {
        return this.properties.find((e) => e.key === key);
    }

    getElement() {
        if (this.elementhandle) {
            return this.hsbmodel.findEntity(this.elementhandle);
        } else if (this.truckPackageEntity) {
            return this.truckPackageEntity;
        }
        return null;
    }

    addProperty(property: Property, options?: {expose?: boolean, overwrite?: boolean}) {
        let {expose, overwrite} = options ?? {};
        if (expose != null) property.expose = expose;
        this._properties.push(property);

        // Store has a key, category - so we can search just on keys
        if (!this._props[property.key]) {
            this._props[property.key] = {};
        }

        this._props[property.key] = property;
        this._props[property.category + '.' + property.key] = property;
    }

    propertyValue(key: string) {
        let prop = this._props[key];
        if (prop) {
            return prop.value;
        }
        return null;
    }
    alignToNewCoordsys(geometry: any, newposCoordSys: CoordSys) {
        if (!geometry) {
            return;
        }

        var currentCoordSys = geometry.matrix.getCoordSys();

        var moveMatrix = new Matrix4();

        currentCoordSys.setToAlignCoordSys(moveMatrix, currentCoordSys, newposCoordSys);

        geometry.applyMatrix4(moveMatrix);
    }
    clone() {
        let self = this;
        let clonedEntity: HsbEntity = Object.create(this);
        clonedEntity._handle = self._handle;
        clonedEntity._properties = self._properties;
        clonedEntity._props = self._props;
        clonedEntity._groups = self._groups;
        clonedEntity._coordSys = self._coordSys;
        clonedEntity.bodydata = self.bodydata;

        return clonedEntity;
    }
}

export class HsbElement extends HsbEntity {
    private _isElement: boolean = true;
    public isElement(): boolean {
        return this._isElement;
    }
    sheets!: Sheet[];
    beams!: Beam[];
    openings!: Opening[];
    ptArrow: any;
    ptarrow: any;
    labelCoordSys!: CoordSys;
    constructor(handle: string | number, number:  number, type: string, objecttype: string) {
        super(handle, type, objecttype, 0);
        this.number = number;
    }

    getDislayName() {
        return this.type + '-' + this.number?.toString();
    }

    getEntities(zone?: number) {
        let self = this;
        return this.hsbmodel.Entities.filter(
            (entity) =>
                self !== entity &&
                entity.elementhandle != null &&
                entity.elementhandle === self.handle &&
                (zone == null || entity.zone === zone)
        );
    }

    getZoneEntities(filterTsl = true) {
        let zoneEntities: { [key: string | number]: any } = {};
        if (!this.entities) return zoneEntities;

        this.entities.forEach((entity) => {
            if (entity.zone !== undefined) {
                if (filterTsl && entity instanceof TslInst) return;

                if (!zoneEntities[entity.zone]) {
                    zoneEntities[entity.zone] = { entities: [], bBox: null };
                }
                zoneEntities[entity.zone].entities.push(entity);
            }
        });

        return zoneEntities;
    }

    override setFactoryVisibilityforZone(zone: number) {
        var entities = this.entities;

        if (entities != null) {
            this.hsbmodel.Entities.forEach((entity) => {
                entity.setFactoryVisibilityforZone(zone);
            });
        }
    }

    override getBoundingBoxLocal() {
        let boundingBox = new Box3();
        let entityCoordSys = this.elementCoordSys ? this.elementCoordSys : this.coordSys;

        let localBodyData = this.getLocalBody(entityCoordSys);
        let elementBox = this.getBodyBoundingBox(localBodyData);
        if (elementBox) {
            boundingBox = elementBox;
        }

        var entities = this.entities;

        if (entities != null) {
            this.entities.forEach((entity) => {
                let localBodyData = entity.getLocalBody(entityCoordSys);
                let bBoxLocal = entity.getBodyBoundingBox(localBodyData);

                if (bBoxLocal && !bBoxLocal.isEmpty()) {
                    boundingBox.union(bBoxLocal);
                }
            });
        }
        return boundingBox;
    }
}
export class ElementWall extends HsbElement {
    private _size!: number;
    public get size(): number {
        return this._size;
    }
    public set size(v: number) {
        this._size = v;
    }

    constructor(handle: string | number, number:  number) {
        super(handle, number, WALL, ObjectType.HsbElementWall);
        this.size = 50.0;
    }
}

export class ElementWallSIP extends HsbElement {
    private _size!: number;
    public get size(): number {
        return this._size;
    }
    public set size(v: number) {
        this._size = v;
    }

    constructor(handle: string | number, number:  number) {
        super(handle, number, WALLSIP, ObjectType.HsbElementWallSIP);
        this.size = 50.0;
    }
}

abstract class ElementRoofBase extends HsbElement {
    private _beamspacing!: number;
    public get beamspacing(): number {
        return this._beamspacing;
    }
    public set beamspacing(v: number) {
        this._beamspacing = v;
    }

    insulation: any;
    beamdirection: any;
    isfloor: boolean = false;
}

export class ElementRoof extends ElementRoofBase {
    constructor(handle: string | number, number:  number) {
        super(handle, number, ROOF, ObjectType.HsbElementRoof);
        this.beamspacing = 50.0;
    }
}

export class ElementRoofSIP extends ElementRoofBase {
    constructor(handle: string | number, number:  number) {
        super(handle, number, ROOFSIP, ObjectType.HsbElementRoofSIP);
        this.beamspacing = 50.0;
    }
}

export class Group extends HsbEntity {
    private _GUID: string;
    floorheight: any;
    equivalentstory: any;
    isdeliverablecontainter: any;
    get GUID() {
        return this._GUID;
    }
    set GUID(GUID) {
        this._GUID = GUID;
    }
    private _house: any;
    get house() {
        return this._house;
    }
    set house(house) {
        this._house = house;
    }
    private _floor: any;
    get floor() {
        return this._floor;
    }
    set floor(floor) {
        this._floor = floor;
    }
    private _element: any;
    get element() {
        return this._element;
    }
    set element(element) {
        this._element = element;
    }
    constructor(handle: string | number) {
        super(handle, GROUP, ObjectType.HsbGroup, 0);
        this._GUID = newGuid();
        this._house = null;
        this._floor = null;
        this._element = null;
    }
    equals(rhs: Group) {
        return this.house === rhs.house && this.floor === rhs.floor && this.element === rhs.element;
    }
}

export abstract class HsbObject extends HsbEntity {
    private _elementid!: string;
    public get elementid(): string {
        return this._elementid;
    }
    public set elementid(v: string) {
        this._elementid = v;
    }
    
    private _color!: string;
    public get color(): string {
        return this._color;
    }
    public set color(v: string) {
        this._color = v;
    }
    private _transparency!: number;
    public get transparency(): number {
        return this._transparency;
    }
    public set transparency(v: number) {
        this._transparency = v;
    }
    constructor(handle: string | number, elementid: string, type: string, objectType: string, zone: string | number) {
        super(handle, type, objectType, zone);
        this.elementid = elementid;
    }

    override getDislayName() {
        if (this.posnum != null && this.posnum > 0) {
            return this.type + '-' + this.posnum.toString();
        }
        return this.type;
    }
}

export class Beam extends HsbObject {
    constructor(handle: string | number, elementid: string, zone: number) {
        super(handle, elementid, BEAM, ObjectType.HsbBeam, zone);
        this.elementid = elementid;
    }
}

export class Sheet extends HsbObject {
    constructor(handle: string, elementid: string, zone: number) {
        super(handle, elementid, SHEET, ObjectType.HsbSheet, zone);
        this.elementid = elementid;
    }
}

export class Opening extends HsbObject {
    constructor(handle: string, elementid: string, zone: number) {
        super(handle, elementid, OPENING, ObjectType.HsbOpening, zone);
        this.elementid = elementid;
    }
}
export class Sip extends HsbObject {
    woodgraindirection: any;
    labelCoordSys!: CoordSys;
    constructor(handle: string, elementid: string, zone: number) {
        super(handle, elementid, SIP, ObjectType.HsbSIP, zone);
        this.elementid = elementid;
    }
}
export class MassGroup extends HsbObject {
    constructor(handle: string, elementid: string, zone: number) {
        super(handle, elementid, MASSGROUP, ObjectType.HsbMassGroup, zone);
        this.elementid = elementid;
    }
}
export class MassElement extends HsbObject {
    constructor(handle: string, elementid: string, zone: number) {
        super(handle, elementid, MASSELEMENT, ObjectType.HsbMassElement, zone);
        this.elementid = elementid;
    }
}
export class TslInst extends HsbObject {
    scriptname!: string;
    constructor(handle: string | number, elementid: string, zone: number) {
        super(handle, elementid, TSLINST, ObjectType.HsbTslInst, zone);
        this.elementid = elementid;
    }
}
export class GenericModel extends HsbObject {
    constructor(handle: string | number, elementid: string, zone: number) {
        super(handle, elementid, GENERICMODEL, ObjectType.HsbGenericModel, zone);
        this.elementid = elementid;
    }
}
export class FastenerAssemblyEnt extends HsbObject {
    constructor(handle: string | number, elementid: string, zone: number) {
        super(handle, elementid, FASTENERASSEMBLYENT, ObjectType.HsbFastenerAssemblyEnt, zone);
        this.elementid = elementid;
    }
}
export class MetalPartCollectionEnt extends HsbObject {
    constructor(handle: string | number, elementid: string, zone: number) {
        super(handle, elementid, METALPARTCOLLECTIONENTITY, ObjectType.HsbMetalPartCollectionEnt, zone);
        this.elementid = elementid;
    }
}
export class BlockReference extends HsbObject {
    blockref: any;
    constructor(handle: string | number, elementid: string, zone: number) {
        super(handle, elementid, BLOCKREFERENCE, ObjectType.HsbBlockReference, zone);
        this.elementid = elementid;
    }
}
export class CollectionEntity extends HsbEntity {    
    constructor(handle: string | number, type?: string, objectType?: string) {
        super(handle, COLLECTIONENTITY, ObjectType.HsbCollectionEntity, 0);
    }

    override getDislayName() {
        if (this.posnum != null && this.posnum > 0) {
            return this.type + '-' + this.posnum.toString();
        }
        return this.type;
    }
}

export class TrussEntity extends CollectionEntity {
    constructor(handle: string | number) {
        super(handle, TRUSSENTITY, ObjectType.HsbTrussEntity);
    }
}
export class Grid extends HsbEntity {
    gridlineXIntersections: any;
    gridlineYIntersections: any;
    sizex?: number;
    sizey?: number;
    textsize?: number;
    textoffset?: number;
    constructor(handle: string) {
        super(handle, GRID, ObjectType.HsbGrid, 0);
    }
}
export class Dimension extends HsbEntity {
    ShowArrows: boolean;
    ShowSegments: boolean;
    ShowReferences: boolean;
    Textheight: any;
    XDirection: any;
    Nodes: any;
    YDirection: any;
    constructor(handle: string) {
        super(handle, DIMENSION, ObjectType.HsbDimension, 0);

        this.ShowArrows = true;
        this.ShowSegments = true;
        this.ShowReferences = true;
    }
}

export class Truck extends HsbEntity {
    truckStacks!: any[];
    constructor(handle: string | number) {
        super(handle, TRUCK, ObjectType.HsbTruck, 0);
    }

    getChildEntities() {
        let truckItem: any[] = [];
        this.truckStacks.forEach((truckStack) => {
            truckStack.nestingChilds.forEach((entity: HsbEntity) => {
                truckItem.push(entity);
            });
        });
        return truckItem;
    }

    getTruckStacks() {
        return this.truckStacks ?? [];
    }
}

export class TruckLayer extends HsbEntity {
    constructor(handle: string | number) {
        super(handle, TRUCKLAYER, ObjectType.HsbTruckLayer, 0);
    }
}

export class Stack extends HsbEntity {
    private _nestingChilds!: HsbEntity[];
    public get nestingChilds(): HsbEntity[] {
        return this._nestingChilds;
    }
    public set nestingChilds(value: HsbEntity[]) {
        this._nestingChilds = value;
    }
    constructor(handle: string | number) {
        super(handle, STACK, ObjectType.HsbStack, 0);
    }
}

export class TruckStack extends HsbEntity {
    truckEntities!: any[];
    constructor(handle: string | number) {
        super(handle, TRUCKSTACK, ObjectType.HsbTruckStack, 0);
    }

    getEntities() {
        return this.truckEntities;
    }
}

export class TruckPack extends HsbEntity {
    constructor(handle: string | number) {
        super(handle, TRUCKPACK, ObjectType.HsbTruckPack, 0);
    }
}

export class TruckItem extends HsbEntity {
    constructor(handle: string | number) {
        super(handle, TRUCKITEM, ObjectType.HsbTruckItem, 0);
    }
}

export class Pack extends HsbEntity {
    constructor(handle: string | number) {
        super(handle, STACK, ObjectType.HsbPack, 0);
    }
}

export class NestingBase extends HsbEntity {
    private _nestingChilds!: HsbEntity[];
    public get nestingChilds(): HsbEntity[] {
        return this._nestingChilds;
    }
    public set nestingChilds(value: HsbEntity[]) {
        this._nestingChilds = value;
    }
    constructor(handle: string | number, type: string, objectType: string, zone: string | number = 0) {
        super(handle, type, objectType, zone);
    }

    getChildEntities() {
        let childEntities: any[] = [];
        this.nestingChilds?.forEach((child: any) => {
            if (child instanceof HsbEntity) {
                childEntities.push(child);
            } else if (child.modelEntity) {
                childEntities.push(child.modelEntity);
            }
        });
        return childEntities;
    }
}

export class Nesting extends NestingBase {
    constructor(handle: string | number) {
        super(handle, NESTING, ObjectType.HsbNesting);
    }
}

export class MultiWall extends HsbEntity {
    childEntities: any = [];
    constructor(handle: string | number) {
        super(handle, MULTIWALL, ObjectType.HsbMultiWall, 0);
    }

    getChildEntities() {
        return this.childEntities;
    }
}

export class NonHsb extends HsbEntity {
    

    constructor(handle: string | number) {
        super(handle, NONHSB, ObjectType.NoSet, 0);
    }

    override getDislayName() {
        return this.type + '-' + this.number.toString();
    }
}

//---------------
//   FACTORY
//---------------

export class FactoryEntity extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, FACTORYENTITY, ObjectType.HsbFactoryEntity, zone);
    }
}

export class FactoryUnit extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, FACTORYUNIT, ObjectType.HsbFactoryUnit, zone);
    }
}

export class FactoryBuffer extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, FACTORYBUFFER, ObjectType.HsbFactoryBuffer, zone);
    }
}

//---------------
//   TRUCK
//---------------
export class TruckEntity extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKENTITY, ObjectType.HsbTruckEntity, zone);
    }
}

export class TruckLoadLayoutBody extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKLOADLAYOUTBODY, ObjectType.HsbTruckLoadLayoutBody, zone);
    }
}

export class TruckLoadLayoutBodyAxle extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKLOADLAYOUTBODYAXLE, ObjectType.HsbTruckLoadLayoutBodyAxle, zone);
    }
}

export class TruckLoadLayoutBodyAxleFace extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKLOADLAYOUTBODYAXLEFACE, ObjectType.HsbTruckLoadLayoutBodyAxleFace, zone);
    }
}

export class TruckLoadLayoutBodyFace extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKLOADLAYOUTBODYFACE, ObjectType.HsbTruckLoadLayoutBodyFace, zone);
    }
}

export class TruckLoadLayoutBodyJoin extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKLOADLAYOUTBODYJOIN, ObjectType.HsbTruckLoadLayoutBodyJoin, zone);
    }
}

export class TruckLoadLayoutCab extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKLOADLAYOUTCAB, ObjectType.HsbTruckLoadLayoutCab, zone);
    }
}

export class TruckLoadSpace extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKLOADSPACE, ObjectType.HsbTruckLoadSpace, zone);
    }
}

export class TruckLoadSpaceFace extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKLOADSPACEFACE, ObjectType.HsbTruckLoadSpaceFace, zone);
    }
}

export class TruckLoadPackage extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, TRUCKLOADPACKAGE, ObjectType.HsbTruckLoadPackage, zone);
    }
}

export class GroundPad extends HsbEntity {
    constructor(handle: string | number, zone: number) {
        super(handle, GROUNDPAD, ObjectType.HsbGroundPad, zone);
    }
}

export interface NodeDoc {
    path: string;
    filename: string;
    ext: string;
    filestat: string;
}
export class Node {
    dbId: string | number;
    name: string | null;
    parent: Node | null;
    children: Node[] | null;
    metadata: any;
    nodeModel: NodeModel;
    pathid!: string;
    commpackage: any;
    hsbmodel: HsbModel | null = null;
    // Referenced entity
    entity: HsbEntity | null = null;
    groupsite: string | null = null;
    subgroup: any;
    set: any;
    docFiles!: NodeDoc[];

    constructor(name: string | null, parent: Node | null, dbId: string | number, nodeModel: NodeModel) {
        this.dbId = dbId;
        this.name = name;
        // hierarchy
        this.parent = parent;
        this.children = [];
        // Props
        this.metadata = {};
        // Tree
        this.nodeModel = nodeModel;
    }

    getReferenceNodes(entity: HsbEntity) {
        let self = this;
        var referenceNodes: Node[] = [];

        if (!this.metadata.data.references) return referenceNodes;

        self.metadata.data.references.forEach((reference: ShareReference) => {
            if (reference.pathid) {
                var dataroot = self.nodeModel.findGroupChildNode(self.nodeModel.root, 'data');
                var refpath = '';
                if (reference.pathid.indexOf('/') === -1) {
                    refpath = reference.pathid;

                    if (reference.model) {
                        dataroot = self.nodeModel.findGroupSiteRootNode(dataroot, reference.model);
                    }
                } else {
                    refpath = reference.pathid;
                }

                if (dataroot) {
                    var refnode = self.nodeModel.findGroupChildNodeByPathId(dataroot, refpath);

                    if (refnode) {
                        if (!entity || refnode.entity === entity) {
                            referenceNodes.push(refnode);
                        }
                    }
                }
            }
        });

        return referenceNodes;
    }
    getLinkedReferenceNodes() {
        let dataroot = this.nodeModel.findGroupChildNode(this.nodeModel.root, 'data');
        if (!dataroot) return [];

        // Find all nodes that point back to this pathid.
        return this.nodeModel.findGroupRefNodesByPathId(dataroot, this.pathid);
    }

    findFactoryStateRefNodesByPathId() {
        let self = this;
        var factoryStatNodes: { factoryStation: Node; jobItems: any[] }[] = [];
        let dataroot = self.nodeModel.findGroupChildNode(self.nodeModel.root, 'data');

        if (self.metadata && self.metadata.data && self.metadata.data.factorystatereferences) {
            self.metadata.data.factorystatereferences.forEach((ref: any) => {
                var refNode = self.nodeModel.findGroupChildNodeByPathId(dataroot, ref.pathid);

                if (refNode) {
                    let factoryStation: { factoryStation: Node; jobItems: any[] } = { factoryStation: refNode, jobItems: [] };
                    factoryStatNodes.push(factoryStation);

                    if (ref.jobreferences) {
                        ref.jobreferences.forEach((jobref: any) => {
                            var refNode = self.nodeModel.findGroupChildNodeByPathId(dataroot, jobref.pathid);

                            if (refNode) {
                                factoryStation.jobItems.push(refNode);
                            }
                        });
                    }
                }
            });
        }

        return factoryStatNodes;
    }
}

export class GroupNode extends Node {
    groupType: 'floor' | 'element' | 'house' | null = null;
    groupElement: any;
}

export class NodeModel {
    _id!: string;
    root;
    hsbProject: any;
    idcounter: number;
    name: any;
    NodeModel: any;
    hsbtype: string = '';
    /**
     * The root for all items (documents, issue etc)
     */
    ItemsRoot!: Node;
    /**
     * The root for all model data (entities etc)
     */
    ModelRoot!: Node;
    externalRef!: string;
    thumbnailDataUrl!: string;
    filteredNodes: Node[] = [];
    constructor(name: string | null, rootnode: string | null, hsbProject: HsbProject) {
        this.idcounter = 1;
        this.name = name;
        this.hsbProject = hsbProject;
        this.root = this.createNode(rootnode, null);
    }

    createNode(name: string | null, parent: Node | null) {
        return new Node(name, parent, this.idcounter++, this);
    }

    addChildNode(node: Node, childnode: Node) {
        if (!node || !childnode) {
            throw new Error('NodeModel::addChildNode(): Node or childNode can not be undefined!');
        }

        if (!node.children) {
            node.children = [childnode];
        } else node.children.push(childnode);
        childnode.parent = node;
        return node;
    }

    deleteNode(node: Node) {
        if (!node) throw new Error('NodeModel::deleteNode(): Node can not be undefined!');
        if (node?.parent?.children) {
            // Check if in children
            let index = node.parent.children.findIndex((child) => child.dbId === node.dbId);
            if (index > -1) node.parent.children.splice(index, 1);
            node.parent = null;
            return index > -1;
        }
        return false;
    }

    /**
     * Performs a search in the given node's children for a node with the given name
     * @param node The node to start the search from
     * @param name The name to search for
     * @returns The name that has the given name, undefined otherwise
     */
    findGroupChildNode(node: Node, name: string): Node | undefined {
        if (!node || !name) {
            throw new Error('NodeModel::findGroupChildNode(): Node and/or name can not be undefined!');
        }
        if (node.children) {
            return node.children.find((c) => c.name?.toLowerCase() === name.toLowerCase());
        }
        return undefined;
    }

    /**
     * This method performs a recursive serach through the tree, starting from the given node and based on the given predicate.
     * @param node The node to start the search with
     * @param predicate The predicate to use for the current node
     * @param continueAfterFalse (Default = true) If true the search will delve deeper into children even though the parent had a false result
     * @returns An array containing all nodes for which the predicate was true
     */
    public recursiveSearchNode(node: Node, predicate: (node: Node) => boolean, continueAfterFalse: boolean = true) {
        let res: Node[] = [];
        if (!node) return res;
        let hit = predicate(node);
        if (hit) {
            res.push(node);
        }
        // If continue after hit is true we always goin into children, else we only do so if the predicate was true
        if ((continueAfterFalse || hit) && node.children && node.children.length > 0) {
            node.children.forEach((child) => {
                let childRes = this.recursiveSearchNode(child, predicate, continueAfterFalse);
                res = res.concat(childRes);
            });
        }
        return res;
    }

    getReferenceNodes(node: Node): Node[] {
        var referenceNodes: Node[] = [];

        if (!node) {
            throw new Error('NodeModel::getReferenceNodes(): Node can not be undefined!');
        }

        if (!node.metadata.data.references) return referenceNodes;

        node.metadata.data.references.forEach((reference: any) => {
            if (reference.pathid) {
                var dataroot = this.findGroupChildNode(this.root, 'data');
                var refpath = '';
                if (reference.pathid.indexOf('/') === -1) {
                    refpath = reference.pathid;

                    if (reference.model) {
                        dataroot = this.findGroupSiteRootNode(dataroot, reference.model);
                    }
                } else {
                    refpath = this.hsbProject.datastoreFolder + reference.pathid;
                }

                if (dataroot) {
                    var refnode = this.findGroupChildNodeByPathId(dataroot, refpath);

                    if (refnode) {
                        referenceNodes.push(refnode);
                    }
                }
            }
        });

        return referenceNodes;
    }

    getShareReferences(node: Node) {
        var shareReferennces: ShareReference[] = [];

        if (!node) {
            throw new Error('NodeModel::getShareReferences(): Node can not be undefined!');
        }

        if (!node.metadata.data.references) return shareReferennces;

        node.metadata.data.references.forEach((reference: ShareReference) => {
            if (!reference) return;

            var refnode;
            var dataRoot = this.findGroupChildNode(this.root, 'data');

            if (reference.pathid) {
                var refpath = '';
                if (reference.pathid.indexOf('/') === -1) {
                    refpath = reference.pathid;

                    if (reference.model) {
                        dataRoot = this.findGroupSiteRootNode(dataRoot, reference.model);
                    }
                } else {
                    refpath = reference.pathid;
                }

                if (dataRoot) {
                    refnode = this.findGroupChildNodeByPathId(dataRoot, refpath);

                    if (refnode) {
                        let shareReference = new ShareReference(refnode);

                        shareReferennces.push(shareReference);
                    }
                }
            } else {
                // New Mongo DB Nodes.
                refnode = this.findGroupChildNodeByPathId(this.ItemsRoot, reference.pathid);

                if (refnode) {
                    if (
                        refnode.metadata.data.itemtype === 'hsbshare.geomreference' &&
                        refnode.metadata.data.references &&
                        refnode.metadata.data.references.length === 1
                    ) {
                        // To get the project mode we need to query the reference in this geomreference node.
                        let ref = refnode.metadata.data.references[0];

                        var projectModelNode = this.findGroupChildNodeByPathId(this.ItemsRoot, ref);

                        if (
                            projectModelNode &&
                            projectModelNode.metadata.data.properties &&
                            projectModelNode.metadata.data.properties['modelId']
                        ) {
                            let dataroot = this.findGroupSiteRootNode(dataRoot, projectModelNode.metadata.data.properties['modelId'].value);

                            if (dataroot && refnode.metadata.data.properties['referenceId'].value) {
                                refnode = this.findGroupChildNodeByPathId(dataRoot, refnode.metadata.data.properties['referenceId'].value);

                                if (refnode) {
                                    let shareReference = new ShareReference(refnode);
                                    shareReferennces.push(shareReference);
                                }
                            }
                        }
                    } else {
                        let shareReference = new ShareReference(refnode);
                        shareReferennces.push(shareReference);
                    }
                }
            }
        });

        return shareReferennces;
    }

    getReferenceNodesByEntity(entity: HsbEntity, itemtype: string) {
        var referenceNodes: Node[] = [];
        let self = this;

        var dataroot = this.findGroupChildNode(this.root, 'data');
        if (!dataroot) return referenceNodes;
        var itemsroot = this.findGroupChildNode(dataroot, 'items');
        if (!itemsroot) return referenceNodes;
        let nodes = this.getNodesMetadataIdByItemType(itemsroot, itemtype);

        return nodes.filter((node) => {
            var references = self.getShareReferences(node);
            return references.some((reference) => reference.modelNode?.entity === entity);
        });
    }

    findGroupSiteRootNode(startnode: any, name: string):any {
        var lcName = name.toLowerCase();

        if (!startnode) return null;

        if (
            (startnode.groupsite && startnode.modelId && startnode.modelId.toLowerCase() === lcName) ||
            (startnode.metadata.data &&
                startnode.metadata.data.roottype === 'model' &&
                startnode.modelId &&
                startnode.modelId.toLowerCase() === lcName)
        ) {
            return startnode;
        }

        if (startnode.children && 0 < startnode.children.length)
            for (var d = 0; d < startnode.children.length; d++) {
                var f = this.findGroupSiteRootNode(startnode.children[d], name);
                if (f) return f;
            }
        return null;
    }

    findGroupSetRootNode(startnode: any, name: string) {
        var lcName = name.toLowerCase();

        function b(c:any):any {
            if (!c) return null;

            if (c.set && c.name.toLowerCase() === lcName) {
                return c;
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        return b(startnode);
    }

    findModelRootNode(startnode:any):any {
            if (!startnode) return null;

            if (startnode.metadata.data && startnode.metadata.data.roottype === NodeType.Model) {
                return startnode;
            }
            if (startnode.children && 0 < startnode.children.length)
                for (var d = 0; d < startnode.children.length; d++) {
                    var f = this.findModelRootNode(startnode.children[d]);
                    if (f) return f;
                }
            return null;
    }

    findGroupChildNodeByPathId(startnode:any, pathid: string, wildcard?: boolean) {
        function b(c:any):any {
            if (!c) return null;

            if (wildcard && c.pathid && c.pathid.indexOf(pathid) !== -1) {
                return c;
            } else if (c.pathid && c.pathid.toLowerCase() === pathid) {
                return c;
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }

        if (!pathid) {
            return null;
        }

        pathid = pathid.toLowerCase();

        return b(startnode);
    }

    filterNodesonItemType(nodes: any[], itemType: string) {
        if (!nodes || !itemType) return null;

        let filteredItems = nodes.filter((node) => {
            return node.metadata.data && node.metadata.data.itemtype && node.metadata.data.itemtype.toLowerCase() === itemType;
        });

        return filteredItems;
    }

    findOriginNode(startnode: any, itemtype: string) {
        function b(c: any): any {
            if (!c) return null;

            if (
                c.metadata &&
                c.metadata.data &&
                c.metadata.data.origin &&
                c.metadata.data.origin === 'datastore' &&
                c.metadata.data.itemtype &&
                c.metadata.data.itemtype === itemtype
            ) {
                return c;
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        return b(startnode);
    }

    findGroupChildNodesByPathId(startnode: Node, pathid: string, wildcard: boolean) {
        return this.recursiveSearchNode(startnode, (node: Node) =>
            wildcard ? pathid.toLowerCase().includes(node.pathid.toLowerCase()) : node.pathid.toLowerCase() === pathid.toLowerCase()
        );
    }

    findGroupRefNodesByPathId(startnode: Node, pathid: string) {
        let self = this;
        let foundNodes = this.recursiveSearchNode(startnode, (node: Node) =>
            node.metadata?.data?.references.find((ref: any) => ref.pathid.toLowerCase() === pathid.toLowerCase())
        );
        return foundNodes.map((n) => self.findGroupChildNodeByPathId(startnode, n.pathid));
    }

    findGroupChildNodesByRefPathId(mainroot: Node, modelname: string, pathid: string) {
        var modelroot = this.findGroupSiteRootNode(mainroot, modelname);
        return this.recursiveSearchNode(modelroot, (node: Node) => node.pathid.toLowerCase() === pathid.toLowerCase());
    }

    findAllChildNodesByRefPathId(datastorefolder, startnode, pathid) {
        var foundnodes: any[] = [];

        function b(c) {
            if (!c) return null;
            if (c.metadata && c.metadata.data && datastorefolder + c.metadata.data.refpath === datastorefolder + pathid) {
                foundnodes.push(c);
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        b(startnode);

        return foundnodes;
    }

    findAllChildNodesofNode(startnode) {
        var foundnodes: any[] = [];

        function b(c) {
            if (!c) return null;

            foundnodes.push(c);
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        b(startnode);

        return foundnodes;
    }

    getconfig() {
        var configroot = this.findGroupChildNode(this.root, 'config');

        if (configroot) {
            var confignode = this.getAllNodes(configroot, NodeType.Configuration);

            if (confignode && confignode.length > 0) {
                if (confignode.length > 1) {
                    // Get the projectconfig file in the hightest folder possible.
                    confignode.sort(function (a, b) {
                        return a.metadata.fileinfo.path.split('/') - b.metadata.fileinfo.path.split('/');
                    });
                }

                return confignode[0].metadata.data;
            }
        }

        return null;
    }

    getconfigNode() {
        // Get config root
        var configroot = this.findGroupChildNode(this.root, 'config');
        if (!configroot) return null;
        // Get highest folder config node
        var confignode = this.getAllNodes(configroot, NodeType.Configuration).sort(
            (a, b) => a.metadata.fileinfo.path.split('/') - b.metadata.fileinfo.path.split('/')
        );
        return confignode[0];
    }

    getnodedefault(nodetype, itemtype) {
        var config = this.getconfig();

        if (config && config.nodedefaults && nodetype && itemtype) {
            var nodedefault = config.nodedefaults.filter((e) => {
                return e.nodetype === nodetype && e.itemtype === itemtype;
            });
            if (nodedefault.length > 0) {
                return nodedefault[0];
            }
        }

        return null;
    }

    findGroupChildNodeByCommpackage(startnode, commpackage) {
        function b(c) {
            if (!c) return null;
            if (c.commpackage != null && c.commpackage.fileinfo.path === commpackage.fileinfo.path) {
                return c;
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }

        if (commpackage == null) {
            return null;
        } else {
            return b(startnode);
        }
    }

    findGroupNode(root, group) {
        if (root == null) {
            return null;
        }

        var foundnode = this.findGroupChildNode(root, group.house);

        if (foundnode != null) {
            if (group.floor == null) {
                return foundnode;
            }

            foundnode = this.findGroupChildNode(foundnode, group.floor);

            if (foundnode != null) {
                if (group.element == null) {
                    return foundnode;
                }

                foundnode = this.findGroupChildNode(foundnode, group.element);
            }
        }

        return foundnode;
    }

    createGroupNode(root: Node, group: Group): GroupNode | null {
        if (root == null) {
            throw new Error('NodeModel.createGroupNode(): Root can not be null!');
        }

        if (!group.house && !group.floor && !group.element) {
            return null;
            throw new Error('NodeModel.createGroupNode(): Invalid group given');
        }

        // First house level
        var housenode = this.findGroupChildNode(root, group.house) as GroupNode;
        if (!housenode) {
            housenode = new GroupNode(group.house, root, this.idcounter++, this);
            housenode.groupType = group.house;
            housenode.pathid = group.handle.toLowerCase();
            housenode.metadata.data = { nodetype: NodeType.Geom, itemtype: NodeType.Geom, refitemtype: RefItemType.Parent };
            housenode.hsbmodel = group.hsbmodel;
            housenode.entity = new NonHsb(housenode.pathid);
            housenode.entity.hsbmodel = housenode.hsbmodel!;
            housenode.entity.node = housenode;
            this.addChildNode(root, housenode);
        }

        let out: GroupNode = housenode;

        // THen floor level
        if (group.floor) {
            var floornode: any = this.findGroupChildNode(housenode, group.floor) as GroupNode;
            if (!floornode) {
                floornode = new GroupNode(group.floor, root, this.idcounter++, this);
                floornode.groupType = group.floor;
                floornode.pathid = group.handle.toLowerCase();
                floornode.metadata.data = { nodetype: NodeType.Geom, itemtype: NodeType.Geom, refitemtype: RefItemType.Parent };
                floornode.hsbmodel = group.hsbmodel;
                floornode.entity = new NonHsb(floornode.pathid);
                floornode.entity.hsbmodel = floornode.hsbmodel!;
                floornode.entity.node = floornode;

                this.addChildNode(housenode, floornode);
            }
            out = floornode;
        }

        if (group.element) {
            var elementnode = this.findGroupChildNode(floornode, group.element) as GroupNode;
            if (!elementnode) {
                elementnode = new GroupNode(group.element, root, this.idcounter++, this);
                elementnode.groupType = group.element;
                elementnode.pathid = group.handle.toLowerCase();
                elementnode.metadata.data = { nodetype: NodeType.Geom, itemtype: NodeType.Geom, refitemtype: RefItemType.Parent };
                elementnode.hsbmodel = group.hsbmodel;
                this.addChildNode(floornode, elementnode);
                elementnode.entity = new NonHsb(elementnode.pathid);
                elementnode.entity.hsbmodel = elementnode.hsbmodel!;
                elementnode.entity.node = elementnode;
            }
            if (elementnode) out = elementnode;
        }
        return out;
    }

    createNoteNode(root, commpackage) {
        if (root == null) {
            return null;
        }

        // Find the collaborations folder in this path
        // 1. The up folder represents the revision name
        // 2. The down folder represents the collaboration category.

        var fullpath = commpackage.fileinfo.path.toLowerCase();

        var paths = commpackage.fileinfo.path.toLowerCase().split('/collaborations/');

        if (paths.length === 2) {
            var revisionfolder = paths[0];
            var revisionname = paths[0].split('/');

            if (revisionname.length > 1) {
                revisionname = revisionname[revisionname.length - 1];
            }

            var categoryname = paths[1].split('/');

            if (categoryname.length > 1) {
                categoryname = categoryname[0];
            }
            var categoryfolder = paths[1] + '/';

            // We may have note trails - these are note folders in note folder. We need  extract all the paths so we can find the existing note nodes to add this note.
            var foldertrail = fullpath.split('/');
            foldertrail.splice(foldertrail.length - 1, 2);
            var parentfolder = fullpath.split(foldertrail[foldertrail.length - 1]);
            var parentfolders = parentfolder[0].split('/collaborations/');
            parentfolders = parentfolders[1].split('/');
            if (parentfolders[parentfolders.length - 1].length === 0) {
                parentfolders.splice(parentfolders.length - 1, 1);
            }

            //parentfolder = parentfolder[0];
            var notepath = fullpath.substring(0, fullpath.lastIndexOf('/'));

            var notesrevisionnode = this.findGroupChildNodeByPathId(root, revisionfolder);
            if (notesrevisionnode == null) {
                notesrevisionnode = this.createNode('Collaboration - ' + revisionname, root);
                notesrevisionnode.pathid = revisionfolder;
                this.addChildNode(root, notesrevisionnode);
            }

            var checkfolder = paths[0] + '/collaborations';
            var currentnode = notesrevisionnode;
            var parentnode;

            if (parentfolders.length === 1) {
                checkfolder += '/' + parentfolders[0];

                parentnode = this.findGroupChildNodeByPathId(notesrevisionnode, checkfolder);
                if (parentnode == null) {
                    parentnode = this.createNode(parentfolders[0], notesrevisionnode);
                    parentnode.pathid = checkfolder;
                    this.addChildNode(notesrevisionnode, parentnode);
                }

                let newnode = this.createNode(commpackage.note.title + ' - (' + commpackage.note.contactname + ')', parentnode);
                newnode.commpackage = commpackage;
                newnode.pathid = notepath;
                this.addChildNode(parentnode, newnode);
            } else {
                for (var x = 0; x < parentfolders.length; x++) {
                    checkfolder += '/' + parentfolders[x];
                }
                parentnode = this.findGroupChildNodeByPathId(notesrevisionnode, checkfolder);
                if (parentnode != null) {
                    let newnode = this.createNode(commpackage.note.title + ' - (' + commpackage.note.contactname + ')', parentnode);
                    newnode.commpackage = commpackage;
                    newnode.pathid = notepath;
                    this.addChildNode(parentnode, newnode);
                }
            }
        }

        return null;
    }

    createCustomNoteNode(root, commpackage, _datastorefolder) {
        if (root == null) {
            return null;
        }

        // Find the collaborations folder in this path
        // 1. The up folder represents the revision name
        // 2. The down folder represents the collaboration category.
        if (commpackage.fileinfo != null) {
            var path = commpackage.fileinfo.path.substring(0, commpackage.fileinfo.path.lastIndexOf('/'));

            var checkfolder = path.split('/');
            checkfolder.pop();
            checkfolder = checkfolder.join('/').toLowerCase();

            var parentnode = this.findGroupChildNodeByPathId(root, checkfolder);
            if (parentnode != null) {
                var newnode = this.findGroupChildNodeByPathId(root, path.toLowerCase());

                if (newnode == null) {
                    var title = commpackage.data.note.title;
                    if (commpackage.data.note.contactname !== '') {
                        title += ' - (' + commpackage.data.note.contactname + ')';
                    }

                    newnode = this.createNode(title, parentnode);
                    newnode.metadata = commpackage;
                    newnode.pathid = path.toLowerCase();
                    this.addChildNode(parentnode, newnode);
                }
            }
        }

        return newnode;
    }

    addMetadata(root, metadata) {
        if (root == null) {
            return null;
        }

        var node;

        if (metadata.fileinfo != null) {
            var path = metadata.fileinfo.path.substring(0, metadata.fileinfo.path.lastIndexOf('/'));

            if (path === '') {
                path = '/';
            }

            node = this.findGroupChildNodeByPathId(root, path.toLowerCase());
            if (node != null) {
                if (metadata.data != null && metadata.data.nodetype == null) {
                    metadata.data.nodetype = 'undefined';
                }

                node.metadata = metadata;

                if (metadata.data._id) {
                    //node.name = metadata.data.uid;
                    node._id = metadata.data._id;
                    node.pathid = metadata.data._id;
                }
            }
        }

        return node;
    }

    createCustomNode(root, nodedata, rootfolder, addFileNode) {
        if (root == null) {
            return null;
        }

        // Find the collaborations folder in this path
        // 1. The up folder represents the revision name
        // 2. The down folder represents the collaboration category.
        var custominfo = nodedata;

        if (nodedata.data != null && nodedata.data.note != null) {
            custominfo = nodedata.fileinfo;
        }

        var fullpath = custominfo.path;
        var lcRootfolder;
        var fullpaths;
        var noderootname;
        var basefolder = false;
        var paths;
        // We need to handle if root folder is just "/"

        if (lcRootfolder !== '/') {
            lcRootfolder = rootfolder.toLowerCase() + '/';

            // split the full path to get the next folder off the root folder.
            var pathid = fullpath.substring(0, fullpath.lastIndexOf('/'));

            // If pathid of file is the same as the root folder just set the path as "/"
            if (pathid + '/' === lcRootfolder) {
                lcRootfolder = '/';
                noderootname = pathid;
                basefolder = true;
            } else {
                fullpaths = fullpath.split(lcRootfolder);

                if (fullpaths.length === 2) {
                    paths = fullpaths[1].split('/');

                    if (paths.length > 1) {
                        noderootname = paths[0];
                    }
                }
            }
        } else {
            // Root folder is just a "/"
            noderootname = lcRootfolder;
        }

        if (noderootname != null) {
            var customrootfolder;
            var folders = [];

            if (lcRootfolder === '/') {
                if (!basefolder) {
                    folders = fullpath.split('/');

                    if (folders.length === 2) {
                        folders.pop();
                    } else if (folders.length > 2) {
                        folders.shift();
                    }
                }

                customrootfolder = noderootname;
            } else {
                paths = fullpath.split(lcRootfolder + noderootname + '/');
                folders = paths[1].split('/');
                customrootfolder = lcRootfolder + noderootname;
            }

            var customrootnode = this.findGroupChildNodeByPathId(root, customrootfolder);
            if (customrootnode == null) {
                customrootnode = this.createNode(noderootname, root);
                customrootnode.pathid = customrootfolder;
                customrootnode.metadata = { data: { nodetype: NodeType.Folder } };
                this.addChildNode(root, customrootnode);
            }

            var checkfolder = '';
            if (customrootfolder !== '/') {
                checkfolder = customrootfolder;
            }

            var parentnode = customrootnode;

            if (folders.length === 0 && nodedata.data) {
                parentnode.metadata.data = nodedata.data;
                parentnode.metadata.fileinfo = nodedata.fileinfo;
            }

            for (var x = 0; x < folders.length; x++) {
                if (addFileNode) {
                    if (x === folders.length - 1 && custominfo.is_dir) {
                        break;
                    }
                } else if (x === folders.length - 1) {
                    // If efs we will have the metadata - this just add to the parentNode.
                    if (parentnode && nodedata.data) {
                        parentnode.metadata.data = nodedata.data;
                        parentnode.metadata.fileinfo = nodedata.fileinfo;
                        if (nodedata.data && nodedata.data._id) {
                            //parentnode.name = nodedata.data.uid;
                            parentnode._id = nodedata.data._id;
                            parentnode.pathid = nodedata.data._id;
                        }
                    }

                    break;
                }

                checkfolder += '/' + folders[x];

                var newnode = this.findGroupChildNodeByPathId(customrootnode, checkfolder);
                if (newnode == null) {
                    newnode = this.createNode(folders[x], parentnode);
                    if (newnode && nodedata.data && nodedata.data._id) {
                        newnode._id = nodedata.data._id;
                    }

                    newnode.pathid = checkfolder;

                    if (x < folders.length - 2) {
                        //newnode.metadata = custominfo;
                        newnode.metadata = { data: { nodetype: NodeType.Folder } };
                    }

                    if (x === folders.length - 2 && nodedata.data != null && nodedata.data.note != null) {
                        var title = nodedata.data.note.title;
                        if (nodedata.data.note.contactname !== '') {
                            title += ' - (' + nodedata.data.note.contactname + ')';
                        }

                        newnode.name = title;
                    }

                    this.addChildNode(parentnode, newnode);
                }

                parentnode = newnode;
            }
        }

        return null;
    }

    createCustomHandleNode(root, nodedata) {
        if (root == null) {
            return null;
        }

        var fullpath = nodedata.path.toLowerCase();

        var pathsplit = fullpath.split(root.pathid.toLowerCase());
        var allsplit = fullpath.split('/');
        allsplit.shift();

        if (allsplit.length > 0) {
            let folders = allsplit;
            //folders.shift();

            var checkfolder = root.pathid.toLowerCase();

            var parentnode = root;

            for (var x = 0; x < folders.length; x++) {
                if (x === folders.length - 1) {
                    break;
                }

                checkfolder += '/' + folders[x];

                var newnode = this.findGroupChildNodeByPathId(root, checkfolder);
                if (newnode == null) {
                    newnode = this.createNode(folders[x], parentnode);
                    newnode.pathid = checkfolder;

                    if (x < folders.length - 2) {
                        //newnode.metadata = custominfo;
                        newnode.metadata = { data: { nodetype: NodeType.Folder } };
                    }

                    if (x === folders.length - 2 && nodedata.data != null && nodedata.data.note != null) {
                        var title = nodedata.data.note.title;
                        if (nodedata.data.note.contactname !== '') {
                            title += ' - (' + nodedata.data.note.contactname + ')';
                        }

                        newnode.name = title;
                        newnode.metadata = nodedata;
                    }

                    this.addChildNode(parentnode, newnode);
                }

                parentnode = newnode;
            }
        }
    }

    findNoteNode(root, noterootname) {
        if (root == null) {
            return null;
        }

        var foundNoteNode: any = null;

        var notesnode = this.findGroupChildNode(root, noterootname);
        if (notesnode != null) {
            foundNoteNode = notesnode;
        }

        return foundNoteNode;
    }

    getNodeById(root, a) {
        function b(c) {
            if (!c) return null;
            if (c.dbId && c.dbId === a) {
                return c;
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        return b(root);
    }

    getNodesById(root, pathid) {
        var foundnodes: any[] = [];

        function b(c) {
            if (!c) return null;

            if (c.dbId === pathid) {
                foundnodes.push(c);
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }

        b(root);

        return foundnodes;
    }

    getNodeByName(a) {
        function b(c) {
            if (!c) return null;
            if (c.name && c.name === a.toLowerCase()) {
                return c;
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        return b(this.root);
    }

    createjsTreedata(root, flatlist) {
        var jtreedata: any[] = [];
        var flatindex = 0;

        function b(c) {
            if (!c) return null;

            var parent;

            if (c === root) {
                parent = '#';
            } else {
                if (flatlist) {
                    parent = root.dbId.toString();
                } else {
                    parent = c.parent.dbId.toString();
                }
            }
            var nodetype = 'folder';

            if (c.pathid != null) {
                var regexdoc = new RegExp('(.*?).(docx|doc|pdf|xml|ppt|xls)$');
                var regeximg = new RegExp('(.*?).(img|jpeg|jpg|bmp|png|gif)$');
                if (regexdoc.test(c.pathid)) {
                    nodetype = 'filedoc';
                }
                if (regeximg.test(c.pathid)) {
                    nodetype = 'fileimage';
                }
            }

            var hidecheck = 'no_checkbox';
            var icon;
            var include = true;

            if (c.metadata.data != null) {
                if (c.metadata.data.icon) {
                    icon = c.metadata.data.icon;
                }

                if (c.metadata.data.nodetype != null) {
                    nodetype = c.metadata.data.nodetype;
                    if (c.metadata.data.refitemtype === RefItemType.Parent || c.metadata.data.refitemtype === RefItemType.Child) {
                        hidecheck = '';
                    }
                }

                // eslint-disable-next-line no-mixed-operators
                if (
                    (c.metadata.data.itemtype && c.metadata.data.itemtype === NodeType.ModelInfo) ||
                    // eslint-disable-next-line no-mixed-operators
                    (c.children &&
                        c.children.length > 0 &&
                        c.children[0].metadata &&
                        c.children[0].metadata.data &&
                        c.children[0].metadata.data.itemtype === NodeType.ModelInfo)
                ) {
                    include = false;
                }
            }

            if (c.name !== NodeType.Item && include) {
                // Remove all cross node connection metadata - this will be regenerated.
                if (c.metadata) {
                    delete c.metadata.itemnode;
                    delete c.metadata.itemnodetreename;
                    delete c.metadata.refitemnodes;
                    delete c.metadata.refitemtreename;
                    delete c.metadata.parentnode;
                    delete c.metadata.refitemnodedata;
                }

                var item: any = {
                    id: c.dbId.toString(),
                    parent: parent,
                    text: c.name,
                    data: { dbId: c.dbId, name: c.name, pathid: c.pathid, metadata: c.metadata },
                    type: nodetype,
                    a_attr: { class: hidecheck },
                };

                if (icon) {
                    item.icon = icon;
                }

                if (!c.skiptree) {
                    jtreedata.push(item);
                }
            }

            if (flatlist && flatindex > 0) {
                return;
            }

            if (c.children && 0 < c.children.length) {
                flatindex++;
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            }
            return null;
        }

        b(root);

        return jtreedata;
    }

    createJsonFormatdata(root, datastorefolder) {
        var newmodeldata: any = [];

        function b(c, item) {
            if (!c) return null;

            if (c.children && 0 < c.children.length) {
                item.children = [];
                for (let d = 0; d < c.children.length; d++) {
                    var metadata = c.children[d].metadata;

                    var newitem = {
                        dbId: c.children[d].dbId,
                        name: c.children[d].name,
                        metadata: metadata,
                    };

                    item.children.push(newitem);
                }

                for (let d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d], item.children[d]);
                    if (f) return f;
                }
            }
        }

        b(root, newmodeldata);

        var model = new this.NodeModel(this.name, this.root.name);
        model.idcounter = this.idcounter;
        model.name = this.name;
        model.root.children = newmodeldata.children;

        return model;
    }

    setParents(a, datastorefolder) {
        function b(c) {
            if (!c) return null;

            // We need to prepend the datastore folder to the users datastore folder.
            if (c.metadata) {
                if (c.pathid && datastorefolder) {
                    c.pathid = datastorefolder + c.pathid;
                }

                if (c.metadata.fileinfo && c.metadata.fileinfo.path && datastorefolder) {
                    c.metadata.fileinfo.path = datastorefolder + c.metadata.fileinfo.path;
                }
            }

            if (c.children && 0 < c.children.length) {
                for (var d = 0; d < c.children.length; d++) {
                    c.children[d].parent = c;

                    var f = b(c.children[d]);
                    if (f) return f;
                }
            }
        }

        b(this.root);
    }

    getAllMetafiles(a, nodetype) {
        var allmetafiles = {};

        function b(c, item = undefined) {
            if (!c) return null;

            if (
                c.metadata &&
                c.metadata.fileinfo &&
                !c.metadata.fileinfo.is_dir &&
                (!nodetype || (c.metadata.data.nodetype && c.metadata.data.nodetype === nodetype))
            ) {
                allmetafiles[c.metadata.fileinfo.path.toLowerCase()] = c.metadata.fileinfo;
            }

            if (c.children && 0 < c.children.length) {
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            }
            return null;
        }

        b(this.root);

        return allmetafiles;
    }

    getAllNodes(start: Node, nodetype: string) {
        return this.recursiveSearchNode(
            start,
            (node: Node) =>
                node.metadata.fileinfo && !node.metadata.fileinfo.is_dir && (!nodetype || node.metadata?.data?.nodetype === nodetype)
        );
    }

    setAllChecked(root, selected) {
        function b(c) {
            if (!c) return null;

            c.selected = selected;

            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        return b(root);
    }

    setChecked(root, dbId, selected) {
        function b(c) {
            if (!c) return null;

            if (c.dbId && c.dbId === dbId) {
                c.selected = selected;
                return;
            }

            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        return b(root);
    }

    getNodeByEntityHandle(a) {
        function b(c) {
            if (!c) return null;
            if (c.entity && c.entity.handle && c.entity.handle === a) {
                return c;
            }
            if (c.children && 0 < c.children.length) {
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            }
            return null;
        }
        return b(this.root);
    }

    getNodeByElementNumber(a) {
        function b(c) {
            if (!c) return null;
            if (c.entity && c.entity instanceof HsbElement && c.entity.number && c.entity.number.toLowerCase() === a.toLowerCase()) {
                return c;
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        return b(this.root);
    }

    getNodesByEntityPosnum(a) {
        var foundnodes: any[] = [];

        function b(c) {
            if (!c) return null;
            if (c.entity && c.entity instanceof HsbEntity && c.entity.posnum && c.entity.posnum === a.toLowerCase()) {
                foundnodes.push(c);
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        b(this.root);

        return foundnodes;
    }

    getParentByNodeType(startnode, nodetype) {
        function b(c) {
            if (!c) return null;
            if (c.metadata.data && c.metadata.data.nodetype && c.metadata.data.nodetype === nodetype.toLowerCase()) {
                return c;
            }
            if (c.parent) {
                var f = b(c.parent);
                if (f) {
                    return f;
                }
            }

            return null;
        }

        if (startnode.metadata.data && startnode.metadata.data.nodetype && startnode.metadata.data.nodetype === nodetype.toLowerCase()) {
            return startnode;
        }

        return b(startnode.parent);
    }

    getChildrenByNodeType(startnode, nodetype) {
        var foundnodes: any[] = [];

        function b(c) {
            if (!c) return null;
            if (c.metadata.data && c.metadata.data.nodetype && c.metadata.data.nodetype === nodetype) {
                foundnodes.push(c);
            }
            if (c.children && 0 < c.children.length) {
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            }
        }

        b(startnode);

        return foundnodes;
    }

    getNodesMetadataId(root, a, filter) {
        var foundnodes: any[] = [];

        function b(c) {
            if (!c) return null;
            if (
                c.metadata.data &&
                c.metadata.data.nodetype &&
                c.metadata.data.nodetype === a.toLowerCase() &&
                (!filter || c.metadata.data[filter])
            ) {
                foundnodes.push(c);
            }
            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        b(root);

        return foundnodes;
    }

    getNodesMetadataIdByItemType(root: Node, itemType: string): Node[] {
        return this.recursiveSearchNode(root, (node: Node) => node.metadata?.data?.itemtype.toLowerCase() === itemType.toLowerCase());
    }

    getChildNodes(root: Node) {
        return this.recursiveSearchNode(root, (node: Node) => node.metadata?.data?.itemtype);
    }

    getChildEntityNodes(root: Node, entity: HsbEntity) {
        return this.recursiveSearchNode(root, (node: Node) => node.entity === entity);
    }

    getNodesMetadataIdByNodeType(root: Node, nodeType: string) {
        return this.recursiveSearchNode(root, (node: Node) => node.metadata?.data?.nodetype === nodeType.toLowerCase());
    }

    getNodesMetadataIdByNodeTypeandName(root: Node, nodeType: string, name: string) {
        return this.recursiveSearchNode(
            root,
            (node: Node) => node.metadata?.data?.nodetype === nodeType.toLowerCase() && node.name?.toLowerCase() === name.toLowerCase()
        );
    }

    getNodesByEntityProperty(root: Node, objecttype: string, propertyname: string, propertyvalue: any, matchtype: string) {
        return this.recursiveSearchNode(
            root,
            (node: Node) => {
                // CHeck objecttype
                return (
                    node.entity?.objecttype === objecttype &&
                    node.entity?.properties.some(({ key, value }) => {
                        // CHeck if needed prop
                        if (key.toLowerCase() !== propertyname.toLowerCase()) return false;
                        // CHeck value
                        let stringValue: string = value.toString().toLowerCase();
                        switch (matchtype) {
                            case 'exact':
                                return stringValue === propertyvalue;
                            case 'fromstart':
                                return stringValue.indexOf(propertyvalue) === 0;
                            default:
                                return stringValue.includes(propertyvalue);
                        }
                    })
                );
            },
            false
        );
    }

    setNodeNameFromEntityPropertyValue(nodes: Node[], searchnode: any) {
        let propertyname = searchnode.nodename.toLowerCase();

        nodes.forEach(function (node) {
            if (node.entity && node.entity.properties) {
                // Mark this as a filtered node.
                node.entity.searchnode = searchnode;

                var foundprop = node.entity.properties.filter(function (e) {
                    return e.key.toLowerCase() === propertyname;
                })[0];

                if (foundprop) {
                    node.name = foundprop.value;
                }
            }
        });
    }

    getNodeProperty(node, propertyKey) {
        if (!node) return null;

        return node.metadata.data.properties.filter(function (e) {
            return e.data.key.toLowerCase() === propertyKey;
        })[0];
    }

    getNodePropertyValue(node, propertyKey) {
        if (!node) return null;
        let found = this.getNodeProperty(node, propertyKey);

        if (found) {
            return found.data.value;
        }

        return '';
    }

    getNodesByEntityPropertyValue(propertyname, propertyvalue, hsbsearchtype) {
        var foundnodes: any[] = [];
        let self = this;
        function b(c) {
            if (!c) return null;
            if (
                c.entity &&
                ((c.entity instanceof HsbEntity && hsbsearchtype === 'Entities') ||
                    (c.entity instanceof HsbElement && hsbsearchtype === 'Elements') ||
                    self.hsbtype === 'All') &&
                c.entity.properties
            ) {
                let foundprop = c.entity.properties.filter((e) => {
                    return e.name === propertyname && e.value.toString().toLowerCase() === propertyvalue.toLowerCase();
                });
                if (foundprop.length === 1) {
                    foundnodes.push(c);
                }
            } else if (hsbsearchtype === 'Groups') {
                if (propertyname === 'Group Level 1' && c.grouphouse && c.name.toLowerCase() === propertyvalue.toLowerCase()) {
                    foundnodes.push(c);
                } else if (propertyname === 'Group Level 2' && c.groupfloor && c.name.toLowerCase() === propertyvalue.toLowerCase()) {
                    foundnodes.push(c);
                } else if (propertyname === 'Group Level 3' && c.groupelement && c.name.toLowerCase() === propertyvalue.toLowerCase()) {
                    foundnodes.push(c);
                } else if (propertyname === 'Group All' && c.name.toLowerCase() === propertyvalue.toLowerCase()) {
                    foundnodes.push(c);
                }
            }

            if (c.children && 0 < c.children.length)
                for (var d = 0; d < c.children.length; d++) {
                    var f = b(c.children[d]);
                    if (f) return f;
                }
            return null;
        }
        b(this.root);

        return foundnodes;
    }
}

export class HsbModel {
    modelId!: string;
    DrawingName!: string;
    Entities: HsbEntity[];
    Groups: Group[];
    boundingBox: Box3;
    HsbModels: {};
    Units: Units;
    projectSource: string;
    name: string;
    constructor(name: string) {
        this.name = name;
        this.Entities = [];
        this.Groups = [];
        this.boundingBox = new Box3();
        this.HsbModels = {};
        this.Units = new Units('mm');
        this.projectSource = 'hsbcad';
    }

    /**
     * Searches for the given group in this model
     * @param group The group to find
     * @returns Group if found, undefined otherwise
     */
    findGroup(group: Group): Group | undefined {
        return this.Groups.find((curr) => curr.equals(group));
    }

    /**
     * Searches for the given group in this model based on its handle.
     * @param handle The handle of the group to find
     * @returns Group if found, undefined otherwise
     */
    findGroupbyHandle(handle: string): Group | undefined {
        return this.Groups.find((curr) => curr.handle === handle);
    }

    /**
     * Searches for the given entity in this model based on its handle
     * @param handle The handle of the entity to find
     * @returns Entity if found, undefined otherwise
     */
    findEntity(handle: string): HsbEntity | undefined {
        return this.Entities.find((curr) => curr.handle === handle);
    }

    /**
     * Searches for the given entity in this model based on its handle
     * @param handle The handle of the entity to find
     * @returns Index of the entity if found, -1 otherwise
     */
    findEntityIndex(handle: string): number {
        return this.Entities.findIndex((curr) => curr.handle === handle);
    }

    /**
     * Returns all hsb entities in this model, by default does NOT include Non Hsb Entities
     * @param getAll (Optional) should this also include non hsb entities
     * @returns All entities
     */
    allHsbEntities(getAll: boolean = false): HsbEntity[] {
        return this.Entities.filter((entity) => getAll || !(entity instanceof NonHsb));
    }
}
